export default {
    channelBalancing : {
        title: "Channel Balancing",
        frequency: "Frequency",
        frequencyName: "Frequency Name",
        modulation: "Modulations",
        channelType: "Channel Types",
        channelTypes: {
            ADMIN: 'Admin',
            BUDDY: 'Buddy',
            FWDL: 'FWDL',
            INSTALL: 'Install'
        },
        traffic: "Traffic",
        trafficCategory: "Traffic Category",
        channelOrder: "Channel Order",
        towers: 'Base Stations Configured',
        towersPrimary: 'Primary Base Stations',
        towersSecondary: 'Secondary Base Stations',
        radiosCurrent: "Radios Current Configurable",
        radiosCurrentTooltip: "Radios on this channel and capability is configurable",
        radiosNonTunable: "Radios Current Not Configurable",
        radiosNonTunableTooltip: "Radios on this channel, capability is NOT Configurable",
        radiosManuallyTuned: "Radios Manually Tuned",
        radiosManuallyTunedTooltip: "Radios on this channel, subsequent tuning actions is manual updates by user",
        radiosAdded: "Radios Moving In",
        radiosAddedTooltip: "Radios not on this channel, balancing to move to this channel, implied capability is configurable",
        radiosRemoved: "Radios Moving Out",
        radiosRemovedTooltip: "Radios on this channel, balancing to move to another channel, implied capability is configurable",
        radiosTarget: "Radios Expected Result",
        radiosTargetTooltip: "Radios current configurable + moving in - moving out, does not include non-tunable radios",
        goal: "Goal (%)",
        actual: "Actual Target (%)",
        actualTunable: "Actual Tunable (%)",
        deviation: "Deviation",
        importNetworkPlan: "Import Network Plan",
        autoBalance: "Auto Balance",
        errorGoal: "Error Setting Goal",
        errorChannelOrder: "Error Editing Channel Order",
        errorAddChannel: "Error Adding Channel",
        errorUpdateChannel: "Error Updating Channel",
        errorDeleteChannel: "Error Deleting Channel",
        deleteChannelPrompt: 'Are you sure you want to delete channel "{frequencyList}" ?',
        deleteChannelSuccess:  'Delete channel success',
        addChannelSuccess:  'Add channel success',
        updateChannelSuccess:  'Update channel success',
        importChannelSuccess: 'Import channel success',
        width: "Width (kHz)",
        lockAll: 'Lock All',
        unlockAll: 'Unlock All',
        toggleLock: 'Toggle Lock',
        uplinkFrequency: 'Uplink Frequency',
        uplinkWidth: 'Uplink Width',
        uplinkModulations: 'Uplink Modulation',
        downlinkFrequency: 'Downlink Frequency',
        downlinkWidth: 'Downlink Width',
        downlinkModulations: 'Downlink Modulation',
        createChannelGoal: 'Create Channel Goal',
        addChannel: 'Add Channel',
        balanceHysteresis:'Reset Channel Balancing Hysteresis',
        confirmBalaceHysteresis: "Are you sure you want to Reset Channel Balancing Hysteresis?",
        resetHysteresisMsg: "{actionType} command sent", 
        resetFailed: "Reset Failed",
        updateChannel: 'Update Channel',
        deleteChannel: 'Delete Channel',
        buddyChannel: 'Buddy Channel',
        editChannelOrder: 'Edit Channel Order',
        channelExistError: 'Channel already exists!',
        orderedChannelList: 'Ordered Channel List',
        totalChannelGoalError: 'Total Channel Goal must equal 100%',
        totalChannelGoalMessage: 'Please make sure the total channel goal of the following traffic or channel type is 100%. \n',
        failureWithoutErrorMsg: 'Failed! No error message was returned',
        exportChannelResults: 'Export Channel Results to File',
        exportChannelConfig: 'Export Channel Config to File',
        importChannelConfig: 'Import Channel Config from File',
        invalidChannelConfigJsonFile: "Failed to Import Channel Config. File is not Valid JSON.",
        invalidChannelConfigJsonLength: "Failed to Import Channel Config. No Channel Definitions Found.",
        importChannelConfigError: "Failed to Import Channel Config. {errorMessage}.",
        importChannelConfigDuplicateError: "Failed to Import Channel Config. Duplicate Frequency: ",
        selectChannelConfigJsonFile: "Select Channel Config JSON File",
        min: "Min of 0",
        max: "Max of 100",
        decimalPlaces: "Up to 2 decimals"
    }
}
